import { render, staticRenderFns } from "./ImagCropper.vue?vue&type=template&id=f83846a0&scoped=true&"
import script from "./ImagCropper.vue?vue&type=script&lang=js&"
export * from "./ImagCropper.vue?vue&type=script&lang=js&"
import style0 from "./ImagCropper.vue?vue&type=style&index=0&id=f83846a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83846a0",
  null
  
)

export default component.exports